import { WebContentAffCodeDto } from '../shared/dto/web-content-aff-code.dto';
import { AffCode } from '../../affcode/shared/affcode.model';
import { AffCodeService } from '../../affcode/shared/affcode.service';
import { NotificationService } from 'src/app/shared';
import { WebContentFormatEnum } from '../shared/enum/web-content-format.enum';
import { WebContentService } from '../shared/web-content.service';
import { WebContentTypeService } from '../shared/web-content-type.service';
import { WebContentDto } from '../shared/dto/web-content.dto';
import { Component, OnInit, EventEmitter, Output, Input, SimpleChanges, OnChanges, ViewEncapsulation } from '@angular/core';
import { ProfileReferralService } from 'src/app/profiles/shared/profile-referral.service';
import { WebContentType } from 'src/app/shared/model/webcontenttype.model';
import { WebContentServiceService } from '../shared/web-content-service.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';

@Component({
  selector: 'wl-web-content-edit-dialog',
  templateUrl: './web-content-edit-dialog.component.html',
  styleUrls: ['./web-content-edit-dialog.component.less'],
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class WebContentEditDialogComponent implements OnInit, OnChanges {
  @Input()
  get show() {
    return this._show;
  }
  set show(value: boolean) {
    this._show = value;
    this.showChange.emit(this._show);
    if (!this._show) {
      this.clearData();
    }
  }
  @Input() profileId: number;
  @Input() isReadOnly: boolean;
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  @Output() webContentSaved: EventEmitter<WebContentDto> = new EventEmitter();

  webContentRecord: WebContentDto;
  webContentTypes: WebContentType[] = [];
  referralTypes: string[] = [];
  webContentFormats: string[] = [];
  webContentFormatEnum = WebContentFormatEnum;
  fileToUpload: File;
  isSaving = false;
  showAccessTextArea = false;
  allAffCodes: string[];
  affCodeSearchResults: string[];
  selectedAffCodes: string[] = [];
  affCodesToDelete: WebContentAffCodeDto[] = [];
  private _show: boolean;
  webContentMemberPortalUrl: string;

  constructor(
    private _webContentTypeService: WebContentTypeService,
    private _webContentService: WebContentService,
    private _notificationService: NotificationService,
    private _affCodeService: AffCodeService,
    private _profileReferralService: ProfileReferralService,
    private _webContentServiceService: WebContentServiceService,
    private _navigationService: NavigationService
  ) {
    this.webContentRecord = {} as WebContentDto;
  }

  ngOnInit(): void {
    this._profileReferralService.getReferralTypes().then((referralTypesResults) => {
      this.referralTypes = referralTypesResults.map((x) => x.ReferralType);
    });

    this._webContentTypeService.getWebContentTypes().then((typesResult) => {
      this.webContentTypes = typesResult.Result;
    });

    this._webContentService.getWebContentFormats().then((formats) => {
      this.webContentFormats = formats;
    });

    this._affCodeService.getAllAffCodes().then((affCodes) => {
      this.allAffCodes = affCodes?.map((x) => x.AffCode);
    });

    this.webContentMemberPortalUrl = this._navigationService.getLegacyDomain() + '/atlas/web-content/';
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.profileId && this.profileId) {
      this.webContentRecord.ProfileID = this.profileId;
    }
  }

  public showModal(webContentId: number = null): void {
    this.show = true;
    if (webContentId) {
      this.loadWebContentRecord(webContentId);
    }
  }

  fileSelected(event: any) {
    const file = event.target.files[0];
    this.fileToUpload = file;
  }

  save() {
    this.isSaving = true;
    this.webContentRecord.RestrictForAffiliations = false;
    if (this.webContentRecord.WebContentAffCodes?.length > 0) {
      this.webContentRecord.RestrictForAffiliations = true;
    }
    if (this.webContentRecord.ContentID) {
      const updatePromises: Promise<void>[] = [];
      this.affCodesToDelete?.forEach((affCodeToDelete) => {
        updatePromises.push(this._webContentServiceService.deleteWebContentAffCode(affCodeToDelete.ID));
      });

      updatePromises.push(this._webContentService.update(this.webContentRecord, this.fileToUpload));

      Promise.all(updatePromises).then(
        () => {
          this.isSaving = false;
          this._notificationService.translateSuccess('web-content.edit.notifications.save-success');
          this.webContentSaved.emit(this.webContentRecord);
          this.show = false;
        },
        (error) => {
          this._notificationService.httpError(error);
          this.isSaving = false;
        }
      );
    } else {
      this._webContentService.create(this.webContentRecord, this.fileToUpload).then(
        (id) => {
          this.isSaving = false;
          this.webContentRecord.ContentID = id;
          this._notificationService.translateSuccess('web-content.edit.notifications.save-success');
          this.webContentSaved.emit(this.webContentRecord);
          this.show = false;
        },
        (error) => {
          this._notificationService.httpError(error);
          this.isSaving = false;
        }
      );
    }
  }

  searchAffCodes(searchEvent: any) {
    this.affCodeSearchResults = this.allAffCodes
      ?.filter((ac) => ac.toLowerCase().includes(searchEvent.query?.toLowerCase()))
      .filter((x) => !this.selectedAffCodes?.find((y) => x === y));
  }

  syncAffCodes() {
    this.webContentRecord.WebContentAffCodes = this.selectedAffCodes?.map(affCode => ({ AffCode: affCode } as WebContentAffCodeDto)) || [];
  }


  private loadWebContentRecord(webContentId: number) {
    this._webContentService.getWebContent(webContentId, true).then((webContentRecord) => {
      this.webContentRecord = webContentRecord;
      if (!this.webContentFormats.find((x) => x === webContentRecord.ContentFormat)) {
        this.webContentFormats.push(webContentRecord.ContentFormat);
      }
      if (this.webContentRecord.WebContentAffCodes?.length > 0) {
        this.selectedAffCodes = this.webContentRecord.WebContentAffCodes.map(x => x.AffCode);
      }
      if (this.webContentRecord.RestrictForAffiliations || this.webContentRecord.RestrictForMembersOnly) {
        this.showAccessTextArea = true;
      }
    });
  }

  private clearData() {
    this.webContentRecord = {} as WebContentDto;
    if (this.profileId) {
      this.webContentRecord.ProfileID = this.profileId;
    }
    this.affCodesToDelete = [];
    this.selectedAffCodes = [];
    this.showAccessTextArea = false;
    this.fileToUpload = null;
  }
}
